import { render, staticRenderFns } from "./AlternativeLocation.vue?vue&type=template&id=4571bc74&scoped=true"
import script from "./AlternativeLocation.vue?vue&type=script&lang=js"
export * from "./AlternativeLocation.vue?vue&type=script&lang=js"
import style0 from "./AlternativeLocation.vue?vue&type=style&index=0&id=4571bc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571bc74",
  null
  
)

export default component.exports